import React from 'react';
import styled from 'styled-components';
import { BasicInput, Checkbox, ElasticTheme, NumberInput, Typography } from '@dev/ee-components';
import { Box } from '@material-ui/core';
import { Segment } from '@dev/ee-api/ee-api-models';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { capitalize } from 'lodash-es';
import { DisableDialog } from '@/store/dialog/actions';

import Props from './RandomNthProps';

const DialogContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    .MuiCheckbox-root {
        padding: 4px 9px;
    }
    .MuiInputBase-root {
        margin-bottom: 16px;
    }
`;
const ModalDescription = styled.div`
    margin-top: -16px;
    margin-bottom: 24px;
    ${ElasticTheme.breakpoints.down('xs')} {
        margin-top: 0px;
    }
`;

export const RandomNthSelection = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { selected } = props;
    const Name: string = 'ListName' in selected ? selected.ListName : (selected as Segment).Name;
    const isList: boolean = 'ListName' in selected;
    let communicationConsent = false;
    const basicListName = `${Name} ${t('random')}`;
    const newList = { ...props.newList };
    newList.Rule = isList ? `List = '${Name}'` : (selected as Segment).IsAllContacts ? null : props.selected.Rule;
    newList.Count = props.singlelist ? 1 : 2;
    newList.ListName = basicListName;
    newList.AllContacts = !isList && (selected as Segment).IsAllContacts;

    const descriptionText = props.singlelist ? t('randomizelistdesc') : t('nthselectionlistdesc');

    return (
        <DialogContainer>
            <ModalDescription>
                <Typography variant="body1" bodyVariant="onPaper">
                    {descriptionText}
                </Typography>
            </ModalDescription>
            <BasicInput
                id="new-list-name-input"
                label={t('listname')}
                defaultValue={basicListName}
                onChange={(e): void => {
                    newList.ListName = e.currentTarget.value;
                    dispatch(DisableDialog(e.currentTarget.value.length === 0 || !communicationConsent));
                    props.onPrepareParams(newList);
                }}
            />
            <NumberInput
                name="listNumber"
                id="list-number-input"
                min={props.singlelist ? 1 : 2}
                step={1}
                max={props.singlelist ? 1000 : 10}
                label={props.singlelist ? t('numberofrandomcontacts') : t('numberoflists')}
                placeholder={props.singlelist ? t('numberofcontacts') : t('numberoflists')}
                defaultValue={props.singlelist ? 1 : 2}
                onClickButton={(e): void => {
                    newList.Count = +e.value;
                    props.onPrepareParams(newList);
                }}
                onChange={(e): void => {
                    newList.Count = +e.currentTarget.value;
                    props.onPrepareParams(newList);
                }}
            />

            <Box mt="20px" mb="5px">
                <Typography variant="h4">{t('required')}</Typography>
            </Box>
            <Checkbox
                id="consent-sub-checkbox"
                name={'consentsub'}
                label={t('descconsentsub')}
                onChange={(e, obj: boolean): void => {
                    communicationConsent = obj;
                    dispatch(DisableDialog(newList.ListName.length === 0 || !communicationConsent));
                    props.onPrepareParams(newList);
                }}
            />
            <Box mt="16px" mb="5px">
                <Typography variant="h4">{capitalize(t('optional'))}</Typography>
            </Box>
            <Checkbox
                id="excluded-blocked-checkbox"
                name="exlideblocked"
                label={t('excludeblocked')}
                onChange={(e, obj: boolean): void => {
                    newList.ExcludeBlocked = obj;
                    props.onPrepareParams(newList);
                }}
            />
            <Checkbox
                id="allow-unsubscribe-checkbox"
                name="allowUnsubscribe"
                label={t('allowunsubscribe')}
                onChange={(e, obj: boolean): void => {
                    newList.AllowUnsubscribe = obj;
                    props.onPrepareParams(newList);
                }}
            />
        </DialogContainer>
    );
};
